import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button, Input, Form, FormGroup, Label, Alert } from "reactstrap";
import customFetch from "../../helpers/fetchClient";


const ROLE_LABELS = {
    1: "Super Admin",
    2: "Administrateur",
    3: "Manager",
    4: "Créateur",
    5: "Utilisateur",
};

const ROLE_BADGES = {
    1: "danger",      // Super Admin
    2: "warning",     // Administrateur
    3: "primary",     // Manager
    4: "info",        // Créateur
    5: "secondary",   // Utilisateur
};
const UserProfile = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordMessage, setPasswordMessage] = useState(null);
    const [passwordError, setPasswordError] = useState(null);

    document.title = "Profil | iXi Manager";

    const getRoleLabel = (user_ROLE_ID) =>
        ROLE_LABELS[Number(user_ROLE_ID)] || "Rôle inconnu";

    const fetchUser = async () => {
        try {
            const data = await customFetch("/api/user/me");
            setUser({
                name: data.name,
                surname: data.surname,
                email: data.email,
                id: data.id,
                phone: data.phone,
                role: data.role,
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setPasswordMessage(null);
        setPasswordError(null);

        if (newPassword !== confirmPassword) {
            setPasswordError("Les mots de passe ne correspondent pas");
            return;
        }

        try {
            const res = await fetch("/api/user/reset-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    user_EMAIL: user.email,
                    newPassword: newPassword,
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                setPasswordError(data.message || "Erreur lors de la réinitialisation du mot de passe");
            } else {
                setPasswordMessage("Mot de passe réinitialisé avec succès !");
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
            }
        } catch (err) {
            console.error(err);
            setPasswordError("Erreur serveur lors de la réinitialisation du mot de passe");
        }
    };

    if (loading) return <div className="p-4 text-center">Chargement...</div>;
    if (!user) return <div className="p-4 text-center text-danger">Impossible de récupérer les données utilisateur</div>;

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="justify-content-center">
                        <Col xl={6} lg={8} md={10}>
                            <Card className="shadow-sm border-0">
                                <CardBody className="p-4">

                                    {/* HEADER PROFIL */}
                                    <div className="text-center mb-4">
                                        <img
                                            src="/iXiVERSE-LOGO-DrkNoBG.png"
                                            alt="Avatar"
                                            //className="rounded-circle mb-3"
                                            style={{ width: "20%", height: "20%" }}
                                        />
                                        <br />
                                        <h3 className="mb-0">
                                            <span style={{ color: "#0944a1", fontWeight: "600" }}>{user.name}</span>
                                            {" "}
                                            <span style={{ color: "#00d6ff", fontWeight: "600" }}>{user.surname}</span>
                                        </h3>
                                        <p className="text-muted mb-2">{user.email}</p>
                                    </div>

                                    {/* INFOS UTILISATEUR */}
                                    <Row className="text-center mb-4">
                                        <Col md={6} className="mb-3">
                                            <div className="border rounded p-3 h-100">
                                                <p className="text-muted mb-1">Téléphone</p>
                                                <h6 className="mb-0">{user.phone || "Non renseigné"}</h6>
                                            </div>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <div className="border rounded p-3 h-100">
                                                <p className="text-muted mb-1">Rôle</p>
                                                <span className={`badge bg-${ROLE_BADGES[user.role] || "secondary"} fs-6`}>
                                                    {getRoleLabel(user.role)}
                                                </span>
                                            </div>

                                        </Col>
                                    </Row>

                                    {/* SECTION MOT DE PASSE */}
                                    <div className="border-top pt-4">
                                        <h5 className="mb-3">🔐 Gestion du mot de passe </h5>

                                        {passwordMessage && (
                                            <Alert color="success" className="text-center">
                                                {passwordMessage}
                                            </Alert>
                                        )}

                                        {passwordError && (
                                            <Alert color="danger" className="text-center">
                                                {passwordError}
                                            </Alert>
                                        )}

                                        <Form onSubmit={handlePasswordReset}>
                                            <FormGroup className="mb-3">
                                                <Label for="newPassword">Nouveau mot de passe</Label>
                                                <Input
                                                    type="password"
                                                    id="newPassword"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    placeholder="••••••••"
                                                    required
                                                />
                                            </FormGroup>

                                            <FormGroup className="mb-4">
                                                <Label for="confirmPassword">Confirmer le mot de passe</Label>
                                                <Input
                                                    type="password"
                                                    id="confirmPassword"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    placeholder="••••••••"
                                                    required
                                                />
                                            </FormGroup>

                                            <div className="text-center">
                                                <Button color="success" size="lg">
                                                    Mettre à jour le mot de passe
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );

};

export default UserProfile;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license